import React from "react";
import PropTypes from "prop-types";

const ALGORITHMS = ["prophet", "autoarima", "ses", "tidemodel", "arima", "holts"];

// OverrideControl renders a small inline <select> for overriding the algorithm
// for a specific series. Defaults to `current`; calls onOverride(series, value)
// on change.
export default function OverrideControl({ series, current, onOverride }) {
  function handleChange(e) {
    onOverride(series, e.target.value);
  }

  return (
    <select
      value={current || ""}
      onChange={handleChange}
      aria-label={`Override algorithm for ${series}`}
      className="rounded-ctrl border border-card-bd bg-card px-1.5 py-0.5 text-xs text-text-2 focus:outline-none focus:ring-2 focus:ring-primary"
    >
      {!current && (
        <option value="" disabled>
          Override…
        </option>
      )}
      {ALGORITHMS.map((alg) => (
        <option key={alg} value={alg}>
          {alg}
        </option>
      ))}
    </select>
  );
}

OverrideControl.propTypes = {
  series: PropTypes.string.isRequired,
  current: PropTypes.string,
  onOverride: PropTypes.func.isRequired,
};

OverrideControl.defaultProps = {
  current: "",
};
